// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// NOTE: You shouldn't be using the metrics module directly. Instead you should be generating
// events the metrics system can listen for.
//
// TODO: api service shouldn't be a dependency (hack to get to session_id)
// TODO: we don't have a session id until we do a search. This needs to be addressed.
//
// TO BE IMPLEMENTED:
//   results.sortMethod
//   results.spotlight
//   misc.feedback
//   misc.about
//   results.database   # db recommender links open in new page - we currently can't hook into this
//   cite/export/email  # we currently have no way of knowing where these events originated from
//   vpn banner         # currently just a hyperlink, will need to be turned into an event
//   session start      # split between client/server?
//
// TO BE IMPROVED:
//   metrics that require a document index (doc number on page) currently
//   have no idea where they are on the page (nor should they). Need to
//   figure out a way to deduce this (without harming performance)
//
// NOT in Summon 2.0:
//   refine.quickFilter
//
// NOT in current metrics (events don't exist yet):
//   preview.cite
//   preview.email
//   savedItems.print
//   preview.print
//   detail.print
//
//   searches done from an external source (parsed from url)
//
class MetricsService {
   $http: any
   $log: any
   api: any
   config: any
   enabled: any
   endpoint: any
   events: any
   metrics: any
   static initClass() {
  
      this.prototype.metrics = {
      // query.search
         "searchbox:query"(data: any) {
            return this.createMetric("search", "query", {
               terms: data.terms,
               keepRefineMents: true,
               page: MetricsService.pageFor(data.source)
            }
            )
         },
  
         "advanced_search:query"(data: any) {
            return this.createMetric("search", "query", {
               terms: data.params.q,
               keepRefineMents: true,
               page: 'advanced'
            }
            )
         },
  
         // refine.facet
         "filters:add"(data: any) {
            return this.createMetric("refine", "facet", {
               facet: data.facet,
               value: data.value,
               enabled: true
            }
            )
         },
  
         "filters:remove"(data: any) {
            return this.createMetric("refine", "facet", {
               facet: data.facet,
               value: data.value,
               enabled: false
            }
            )
         },
  
         // refine.moreFacets
         "filters:more"(data: any) {
            return this.createMetric("refine", "moreFacets",
               {facet: data.facet})
         },
  
         // results.save + detail.save
         "document:save"(data: any) {
            if (data.document && data.document.id) {
               switch (data.source) {
                  case "search":
                     return this.createMetric("results", "save",
                     // recordIndex: 0 # FIXME: real recordindex
                        {id: data.document.id})
                  case "detail":
                     return this.createMetric("detail", "save",
                        {id: data.document.id})
               }
            }
         },
  
         // results.detail
         "document:detail"(data: any) {
            return this.createMetric("results", "detail",
               // TODO: Pending define recordIndex according to API Definition.
               // recordIndex: 1
               {id: data.document.id})
         },
  
         // advancedSearch.toggle
         "advanced_search:open"(data: any) {
            return this.createMetric("advancedSearch", "toggle", {
               enabled: true,
               page: MetricsService.pageFor(data.source)
            }
            )
         },
  
         "advanced_search:close"(data: any) {
            return this.createMetric("advancedSearch", "toggle", {
               enabled: false,
               page: MetricsService.pageFor(data.source)
            }
            )
         },
  
         // results.page
         "results:more"(data: any) {
            return this.createMetric("results", "page",
               {recordIndex: data.page})
         },
  
         // results.relatedQuery
         "query_suggestion:query"(data: any) {
            return this.createMetric("results", "relatedQuery", {
               originalQuery: data.originalQuery,
               relatedQuery: data.query
            }
            )
         },
  
         // language.language
         "language:switch"(data: any) {
            return this.createMetric("language", "language",
               {locale: data.locale})
         },
         // page: "unknown" # FIXME
  
         // savedItems.toggle
         "saved_items:open"() {
            return this.createMetric("savedItems", "toggle", {enabled: true})
         },
  
         "saved_items:close"() {
            return this.createMetric("savedItems", "toggle", {enabled: false})
         },
  
         // search.autocomplete
         "autocomplete:select"(data: any) {
            return this.createMetric("search", "autocomplete", {
               recordIndex: data.index,
               terms: data.terms
            }
            )
         },
  
         // misc.help
         "dialog:help"() {
            return this.createMetric("misc", "help", {})
         }
      }
   }
   static pageFor(s: any) {
      switch (s) {
         case "home":
            return "front"
         case "search":
            return "results"
      }
   }

   constructor(events: any, configService: any, $log: any, api: any, $http: any) {
      this.handle = this.handle.bind(this)
      this.createMetric = this.createMetric.bind(this)
      this.getSessionId = this.getSessionId.bind(this)
      this.events = events
      this.$log = $log
      this.api = api
      this.$http = $http
      this.config   = configService.data.metrics
      this.endpoint = this.config.url
      this.enabled = this.config.enabled
      this.events.subscribe("actions", "*", this.handle)
   }

   handle(channel: any, type: any, data: any) {
      let metric
      if (!this.enabled) { return }
      if (metric = this.metrics[type]) {
         return this.log(metric.call(this, data))
      }
   }

   log(event: any) {
      // angular messes with how we post the data, which is really not helping
      $.ajax({
         type: 'POST',
         url: this.endpoint,
         contentType: "application/x-www-form-urlencoded",
         async: true,
         timeout: 1500,
         data: {
            eventData: JSON.stringify(event)
         }
      })
      return this.$log.info("[METRICS]", event)
   }

   //# private ##

   bagNameFor(component: any, method: any) {
      return component + method.charAt(0).toUpperCase() + method.substring(1)
   }

   createMetric(component: any, method: any, payload: any) {
      const bagName = this.bagNameFor(component, method)
      const data = {
         action:         "ui",
         sessionId:      this.getSessionId(),
         client:         this.config.client,
         authenticated:  this.config.authenticated,
         component,
         method
      }
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      data[bagName] = payload
      return data
   }

   getSessionId() {
      return this.api.session_id
   }
}
MetricsService.initClass()

MetricsService.$inject = ["eventService", "configService", "$log", "apiService", "$http"]

angular.module('summonApp.services')
   .service("metricsService", MetricsService)
